// biome-ignore lint/style/noRestrictedGlobals: encapsulation
export const { sqrt } = Math;
